/*
 * @Desc:
 * @Version: v1.00
 * @Author: Forjune
 * @Date: 2024-08-09 15:38:57
 * @LastEditors: Forjune
 * @LastEditTime: 2024-08-14 14:52:06
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";
import Vant from "vant";
import "vant/lib/index.css";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "axios";
// import Vconsole from "vconsole";
// new Vconsole();
Vue.use(Vant);
Vue.use(ElementUI)
Vue.config.productionTip = false;

new Vue({
  axios,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
